import { MetricField } from '@/__generated__/graphql';

export const ALLOWED_METRIC_FIELDS: MetricField[] = [
  MetricField.AccumulatedVolume,
  MetricField.Angle,
  MetricField.Conductivity,
  MetricField.DissolvedOxygen,
  MetricField.DissolvedOxygenSaturation,
  MetricField.Flow,
  MetricField.GateSensorCurrent,
  MetricField.GateSensorDistance,
  MetricField.Level,
  MetricField.LevelRaw,
  MetricField.OriginalDistance,
  MetricField.Orp,
  MetricField.Ph,
  MetricField.Position,
  MetricField.SnowLevel,
  MetricField.SnowLevelNonCalibrated,
  MetricField.SnowRadiation,
  MetricField.SnowTemperature,
  MetricField.SnowWaterEquivalent,
  MetricField.SnowWaterEquivalentNonCalibrated,
  MetricField.SnowWeight,
  MetricField.Temperature,
  MetricField.TurbidityFnu,
  MetricField.TurbidityNtu,
  MetricField.Velocity,
  MetricField.VolumeDay,
  MetricField.VolumeHour,
  MetricField.VolumeMonth,
];
